<template>
  <v-app id="main_page" :dark="theme === 1">
    <template>

      <v-toolbar app fixed clipped-left color="primary" v-bind:style="hide_header_style" dark>
        <v-toolbar-title @click="btn_onclick" style="cursor:pointer;">mySuite</v-toolbar-title>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn flat style="background-color: #f5f5f5; color: rgba(0,0,0,0.87)" v-on="on" href="https://investors.sgx.com/market/security-details/stocks/LMS?from=/" target="_blank">
              
              SGX (LMS): {{ stock_data.price }}
              <v-icon :color="stock_data.trend_color">{{ stock_data.trend_icon }}</v-icon>
            </v-btn>
          </template>
          <span> Last Update: {{ stock_data.lastupdate }}</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-btn icon @click="refresh()">
          <v-icon>refresh</v-icon>
        </v-btn>

        <v-btn icon @click="onClick_theme()" v-if="theme % 2 === 0">
          <v-icon>dark_mode</v-icon>
        </v-btn>
        <v-btn icon @click="onClick_theme()" v-if="theme % 2 === 1">
          <v-icon>light_mode</v-icon>
        </v-btn>

          <v-menu left offset-y v-if="false">
          <template #activator="{ on: menu }">
            <v-tooltip bottom>
              <template #activator="{ on: tooltip }">
                <v-btn outline small fab color="white" v-on="{ ...tooltip, ...menu }">{{ language }}</v-btn>
              </template>
              <span>Languange</span>
            </v-tooltip>
          </template>

          <v-list dense>
            <v-list-tile ripple @click="onClick_lang('en')">
              <v-list-tile-action>EN</v-list-tile-action>
            </v-list-tile>

            <v-list-tile ripple @click="onClick_lang('cn')">
              <v-list-tile-action>中文(简)</v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
        

        <v-menu left offset-y>
          <template #activator="{ on: menu }">
            <v-tooltip bottom>
              <template #activator="{ on: tooltip }">
                <v-btn fab small dark color="success" v-on="{ ...tooltip, ...menu }" v-if="signedIn">
                  {{ username_short }}
                </v-btn>
                <v-btn icon v-on="menu" v-else>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <span v-if="signedIn">{{ username }}</span>
            </v-tooltip>
          </template>

          <v-list dense v-if="signedIn">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ username }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile ripple @click="logout()">
              <v-list-tile-action>
                <v-icon>logout</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Sign Out</v-list-tile-title>
            </v-list-tile>
          </v-list>

          <v-list dense v-else>
            <v-list-tile ripple @click="login()">
              <v-list-tile-action>
                <v-icon>login</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Sign In</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

      </v-toolbar>

    </template>

    <v-snackbar
      v-model="msgbox.show"
      :color="msgbox.color"
      multi-line
      :timeout="msgbox.timeout"
      top
    >
      <span v-html="msgbox.text"></span>
      <v-btn @click="msgbox.show = false" color="#cecece">Close</v-btn>
    </v-snackbar>

    <v-content v-bind:style="reset_padding_top">
      <v-container fluid grid-list-md v-show="breadcrumbs.length>0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-breadcrumbs :items="breadcrumbs" class="pa-0">
              <template v-slot:divider>
                <v-icon>chevron_right</v-icon>
              </template>
              <template v-slot:item="props">
                <a v-on:click="onClick_breadcrumb(props.item)" style="font-size:17px;">{{ $t(props.item.display_text) }}</a>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
      </v-container>

      <router-view />
    </v-content>

    <v-footer app v-bind:style="hide_footer_style">
      <v-layout row wrap class="text-xs-center">
        <v-flex>
          <span>MY CO2 &copy; 2021 - <i>{{ appVersion }}</i></span>
        </v-flex>
      </v-layout>
    </v-footer>

    <v-dialog v-model="loader.show" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Processing please stand by...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import auth from "./functions/auth";
import common from "./functions/general";

export default {
  name: "HrmApp",
  data() {
    return {
      loader: { show: false },
      signedIn: false,
      username: "",
      username_short: "",
      hide_header_style:{},
      reset_padding_top:{},
      hide_footer_style:{},
      msgbox: {
        show: false,
        text: "",
        color: "",
        timeout: 6000
      },
      appVersion: "",
      breadcrumbs: [],
      stock_data: {
        price: null,
        lastupdate: null,
        trend_icon: null,
        trend_color: ""
      },
      theme: 0,
      language: "EN",
      profile: {}
    };
  },
  created() {
    let self = this;
    auth.onChange = async function(blSignIn) {
      self.signedIn = blSignIn;
      if (blSignIn) {
        self.username = auth.getUsername();
        self.username_short = self.username.slice(0, 2);
        self.appVersion = auth.getAppVersion();

      } else {
        window.location.href = "/login?redirect=" + window.location.href;
        // self.$router.push({ name: "Login" });
      }
    };

    auth.hideHeader = function(action){
      if(action){
        self.hide_header_style = {display:'none'};
        self.reset_padding_top = {"padding-top":"0"};
      } else {
        self.hide_header_style = {};
        self.reset_padding_top = {};
      }
    };

    auth.hideFooter = function(action){
      if(action){
        self.hide_footer_style = {display:'none'};
        // self.reset_padding_top = {"padding-top":"0"};
      } else {
        self.hide_footer_style = {};
        // self.reset_padding_top = {};
      }
    }
  },
  async mounted() {
    this.signedIn = auth.loggedIn();
    this.username = auth.getUsername();

    if (this.username) {
      this.username_short = this.username.slice(0, 2);
    }
    this.appVersion = auth.getAppVersion();

    this.profile = auth.getProfile(this.signedIn);
    this.language = this.profile.language;
    this.theme = this.profile.theme;
    this.mode(this.theme);

    // var pageID = common.App.get_pageID();
    // if (pageID) {
    //   this.breadcrumbs = await common.App.get_breadcrumb(pageID);
    // }

    var pageUUID = common.App.get_pageUUID();
    let menu = auth.getMenu().concat(auth.getMenu_int());
    let bc = [];
    if (pageUUID) {
      // djangoDB
      bc = await common.App.get_breadcrumb(pageUUID, menu);
    } else if (pageUUID == "") {
      // arangoDB
      let _id = common.App.getQueryString("_id");
      bc = await common.App.get_breadcrumb_arg(_id, menu);
    } // home where pageUUID = undefined

    this.breadcrumbs = bc.reverse();
    
    var url = 'https://ccf-service.aizenz.com/sgx';
    var response = await fetch(url);
    var sgx = await response.json();
    
    var datetimeStr = sgx.data.prices[0].trading_time; // GMT +8
    var datetimeISO = [
      datetimeStr.slice(0, 4),
      "-",
      datetimeStr.slice(4, 6),
      "-",
      datetimeStr.slice(6, 8),
      "T",
      datetimeStr.slice(9, 11),
      ":",
      datetimeStr.slice(11, 13),
      ":",
      datetimeStr.slice(13, 15),
      "Z"
    ];
    datetimeISO = datetimeISO.join("");

    this.stock_data.lastupdate = new Date(datetimeISO).toLocaleString();
    this.stock_data.price = sgx.data.prices[0].lt;

    var trend = sgx.data.prices[0].c;
    if (trend>0) {
      this.stock_data.trend_icon = "arrow_drop_up";
      this.stock_data.trend_color = "success";
    } else if (trend<0) {
      this.stock_data.trend_icon = "arrow_drop_down";
      this.stock_data.trend_color = "error";
    }
  },
  methods: {
    logout() {
      auth.logout();
    },
    login() {
      window.location.href = "/login";
    },
    async refresh() {
      await auth.refreshMenu();
    },
    btn_onclick() {
      // this.$router.push({ name: "Home" });
      window.location.href = "/home";
    },
    onClick_breadcrumb(data) {
      var method = data.method__class_name + "-" + data.method__column_name + "-" + data.method__key;
      switch(method) {
        case "Page-method-1":
          window.open(data.path);
          break;

        case "Page-method-3":
          this.dialog.visible = true;
          this.dialog.iframe_url = data.component_path.iframe_path;
          break;

        default:
          // window.location.href = data.path + "?pageid=" + data.id;
          var temp_url = data.path + "?orderDesc=" + data.component_path.orderDesc + "&uuid="
          if (data._id == undefined) {
            window.location.href = temp_url + data.uuid;
          } else {
            window.location.href = temp_url + "&_id=" + data._id;
          }
          
      }
    },
    mode (current_mode) {
      this.theme = current_mode;
      
      // Note: veutify.js default theme = light.
      var light = {
        primary: '#673ab7',
        secondary: '#e91e63',
        accent: '#9ec8c8',
        error: '#f44336',
        warning: '#00bcd4',
        info: '#ff9800',
        success: '#4caf50',
        dull: '#f5f5f5',
        dull_mid: '#BDBDBD'
      };

      var dark = {
        primary: '#ac87ec',//'#b298df',
        secondary: '#e91e63',
        accent: '#607d8b',
        error: '#f44336',
        warning: '#57aef4',//'#00bcd4',
        info: '#ff9800',
        success: '#4caf50',
        dull: '#212121',
        dull_mid: '#757575'
      };

      switch(this.theme) {
        case 1:
          this.$vuetify.theme = dark;
          break;

        default:
          this.$vuetify.theme = light;
      }
    },
    onClick_theme () {
      if (this.theme % 2 === 1) {
        this.theme = this.theme - 1;
      } else {
        this.theme = this.theme + 1;
      }

      this.profile.theme = this.theme;

      // to update store2 & DB
      auth.setProfile(this.signedIn, this.profile);

      this.mode(this.theme);

      return 
    },
    onClick_lang (lang) {
      this.$i18n.locale = lang;
      this.language = lang;
      
      this.profile.language = this.language;
      auth.setProfile(this.signedIn, this.profile);
    }
  }
};

</script>